import * as types from './types';

export const applyFilter = (filter) => ({
  type: types.APPLY_FILTER,
  filter,
});

export const updateProfiles = (profiles) => ({
  type: types.UPDATE_PROFILES,
  profiles,
});

export const asyncHttpReqStarted = () => ({
  type: types.ASYNC_HTTP_REQ_STARTED,
});

export const asyncHttpReqEnded = () => ({
  type: types.ASYNC_HTTP_REQ_ENDED,
});

export const changeActiveDashboardId = (dashboardId) => ({
  type: types.CHANGE_ACTIVE_DASHBOARD_ID,
  dashboardId,
});

export const addNewDashboard = (newDashboard) => ({
  type: types.ADD_NEW_DASHBOARD,
  newDashboard,
});

export const updateInterval = (from, to, shortcut, dashboardType) => ({
  type: types.INTERVAL_SELECTION,
  from,
  to,
  shortcut,
  dashboardType,
});

export const updateGranularity = (granularity) => ({
  type: types.UPDATE_GRANULARITY,
  granularity,
});

export const toggleModal = (modalType) => ({
  type: types.TOGGLE_MODAL,
  modalType,
});

export const setDimensionsTypeOnFilters = (data) => ({
  type: types.SET_DIMENSION_TYPE_IN_FILTER,
  data,
});

export const updateFeatures = (features) => ({
  type: types.UPDATE_FEATURES,
  features,
});

export const updateAppAllMetrics = (appAllMetrics) => ({
  type: types.UPDATE_APP_ALL_METRICS,
  appAllMetrics,
});

export const updateUserDefinedMetrics = (userDefinedMetrics) => ({
  type: types.UPDATE_USER_DEFINED_METRICS,
  userDefinedMetrics,
});

export const setSharingState = (sharingState) => ({
  type: types.SET_SHARING_STATE,
  sharingState,
});

export const resetDiagnostics = () => ({
  type: types.RESET_DIAGNOSTICS,
});

export const changeCollapseStatus = (key) => ({
  type: types.CHANGE_COLLAPSE_STATUS,
  key,
});

export const openCollapse = (key) => ({
  type: types.OPEN_COLLAPSE,
  key,
});

export const closeCollapse = (key) => ({
  type: types.CLOSE_COLLAPSE,
  key,
});

export const setAppBackendType = (module) => ({
  type: types.SET_APP_BACKEND_TYPE,
  module,
});

export const changeIsSharingPage = (isSharingPage = false) => ({
  type: types.CHANGE_IS_SHARING_PAGE,
  isSharingPage,
});

/* TODO: For future reference,
 * Use below id in the editor to find the occurences of it's relative references.
 * Editor search key: dashboard_types_UUE93ID
 */
export const updateDashboardType = (dashboardTypeObj) => ({
  type: types.UPDATE_DASHBOARD_TYPE,
  dashboardTypeObj,
});

export const persistState = (configuration) => ({
  type: types.PERSIST_STATE,
  configuration,
});

export const closeAllTabs = () => ({
  type: types.CLOSE_ALL_TABS,
});

export const refreshTrends = () => ({
  type: types.REFRESH_TRENDS,
});

export const toggleLayout = (layout) => ({
  type: types.TOGGLE_LAYOUT,
  layout,
});

export const toggleAnnotations = (value) => ({
  type: types.TOGGLE_ANNOTATIONS,
  value,
});

export const setRealTimeMode = (flag) => ({
  type: types.SET_REAL_TIME_MODE,
  flag,
});

export const setAiAlertsMapping = (mapData) => ({
  type: types.AI_ALERTS_DIMENSION_MAPPING,
  mapData,
});

export const setAiAlertsSensitivity = (payload) => ({
  type: types.SET_AI_ALERTS_SENSITIVITY,
  payload,
});

export const setAiAlertsMetricsMeta = (payload) => ({
  type: types.SET_AI_ALERTS_METRICS_META,
  payload,
});
